export const backToWallet = 'BACK TO WALLET';
